export default {
    progressBar: { marginTop: "10px", width: "100%" }
};
